export enum AnalyticsOutcomeEvents {
    JENNY_BUBBLE_OPENED = 'Jenny bubble opened',
  
    PRONUNCIATION_PRACTICE_COMPLETED = 'Pronunciation practice completed',
    ENGLISH_CENTRAL_PRACTICE_COMPLETED = 'English Central Practice Completed',
    NEWS_PRACTICE_COMPLETED = 'News Practice Completed',
    COMMON_EXPRESSIONS_PRACTICE_COMPLETED = 'Common expressions Practice Completed',
  
    LFA_CONVERSION = 'LFA conversion',
  
    LC_ONBOARDING_COMPLETED = 'LC onboarding completed',
  
    LAST_GC_REQUESTED = 'Last group class requested',
    LAST_PC_REQUESTED = 'Last private class requested',
    LAST_PC_ATTENDED = 'Last private class attended',
    LAST_GC_ATTENDED = 'Last group class attended',
  
    LAST_LESSON_COMPLETED = 'Last lesson completed',
  
    RENEWAL = 'Renewal',
  }


// WEBPACK FOOTER //
// ./ts/app/shared/types/analytics-outcome.types.ts